// Part of taxPages, split to keep files short; ../taxPages.ts merges the parts. Keys sit directly under taxPages.
export const en = {
  ewayBill: {
    title: 'E-way bill',
    testBill: 'Test e-way bill',
    ewbNo: 'EWB {{number}}',
    throughIrp: 'through the IRP',
    expiredOn: 'Expired {{when}}',
    validUntil: 'Valid until {{when}}',
    partAOnlyHint: 'Part A only: add the vehicle before the goods move',
    vehicle: 'Vehicle {{number}}',
    transportDoc: 'Transport doc. {{number}}',
    wasCancelled: 'EWB {{number}} was cancelled.',
    required: 'Required:',
    generate: 'Generate e-way bill',
    updateVehicle: 'Update vehicle',
    addVehicle: 'Add vehicle (Part B)',
    cancelBill: 'Cancel e-way bill',
    toastGenerated: 'E-way bill {{ewbNo}} generated for {{number}}.',
    toastGeneratedDoc: 'E-way bill {{ewbNo}} generated for the document.',
    generateHint:
      "{{subSupply}} · PIN {{pins}}. Give the vehicle now, or the transporter's ID for Part A only.",
    generateHintIrn:
      "{{subSupply}} · PIN {{pins}} · generated through the IRP with the IRN. Give the vehicle now, or the transporter's ID for Part A only.",
    distance: 'Distance (km) *',
    distanceHint: '0 lets the portal work it out from the PIN codes',
    vehicleNo: 'Vehicle no.',
    vehicleType: 'Vehicle type',
    vehicleRegular: 'Regular',
    vehicleOdc: 'Over-dimensional cargo',
    transDocNo: 'Transport doc. no.',
    transDocNoHint: 'RR, airway bill or bill of lading',
    transDocDate: 'Transport doc. date',
    transporterId: 'Transporter ID',
    transporterIdHint: 'GSTIN or TRANSIN',
    transporterName: 'Transporter name',
    generating: 'Generating…',
    generateButton: 'Generate',
    updateVehicleTitle: 'Update vehicle (Part B)',
    updateVehicleHint:
      'A new vehicle or transport document restarts the validity from now for the distance left.',
    vehicleNoRequired: 'Vehicle no. *',
    transDocNoRequired: 'Transport doc. no. *',
    distanceLeft: 'Distance left (km)',
    fromPlace: 'From place *',
    fromState: 'From state *',
    toastUpdated: 'E-way bill {{ewbNo}} updated.',
    update: 'Update',
    cancelTitle: 'Cancel e-way bill {{ewbNo}}',
    cancelHint:
      'An e-way bill can be cancelled within 24 hours of generation, before the goods are verified in transit. This cannot be undone.',
    reason: 'Reason',
    remark: 'Remark',
    keepIt: 'Keep it',
    toastCancelled: 'E-way bill {{ewbNo}} cancelled.',
  },
};

export const ar = {
  ewayBill: {
    title: 'بوليصة الشحن الإلكترونية (E-way bill)',
    testBill: 'بوليصة شحن تجريبية',
    ewbNo: 'EWB {{number}}',
    throughIrp: 'عبر IRP',
    expiredOn: 'انتهت في {{when}}',
    validUntil: 'صالحة حتى {{when}}',
    partAOnlyHint: 'الجزء A فقط: أضف المركبة قبل نقل البضائع',
    vehicle: 'المركبة {{number}}',
    transportDoc: 'مستند النقل {{number}}',
    wasCancelled: 'أُلغيت بوليصة الشحن EWB {{number}}.',
    required: 'مطلوبة:',
    generate: 'إنشاء بوليصة الشحن',
    updateVehicle: 'تحديث المركبة',
    addVehicle: 'إضافة مركبة (الجزء B)',
    cancelBill: 'إلغاء بوليصة الشحن',
    toastGenerated: 'أُنشئت بوليصة الشحن {{ewbNo}} للمستند {{number}}.',
    toastGeneratedDoc: 'أُنشئت بوليصة الشحن {{ewbNo}} للمستند.',
    generateHint:
      '{{subSupply}} · الرمز البريدي {{pins}}. أدخل المركبة الآن، أو معرّف الناقل للجزء A فقط.',
    generateHintIrn:
      '{{subSupply}} · الرمز البريدي {{pins}} · أُنشئت عبر IRP برقم IRN. أدخل المركبة الآن، أو معرّف الناقل للجزء A فقط.',
    distance: 'المسافة (كم) *',
    distanceHint: 'القيمة 0 تجعل البوابة تحسبها من الرموز البريدية',
    vehicleNo: 'رقم المركبة',
    vehicleType: 'نوع المركبة',
    vehicleRegular: 'عادية',
    vehicleOdc: 'حمولة تتجاوز الأبعاد',
    transDocNo: 'رقم مستند النقل',
    transDocNoHint: 'إيصال سكك حديدية أو بوليصة شحن جوي أو بحري',
    transDocDate: 'تاريخ مستند النقل',
    transporterId: 'معرّف الناقل',
    transporterIdHint: 'GSTIN أو TRANSIN',
    transporterName: 'اسم الناقل',
    generating: 'جارٍ الإنشاء…',
    generateButton: 'إنشاء',
    updateVehicleTitle: 'تحديث المركبة (الجزء B)',
    updateVehicleHint: 'مركبة أو مستند نقل جديد يعيد بدء الصلاحية من الآن للمسافة المتبقية.',
    vehicleNoRequired: 'رقم المركبة *',
    transDocNoRequired: 'رقم مستند النقل *',
    distanceLeft: 'المسافة المتبقية (كم)',
    fromPlace: 'من مكان *',
    fromState: 'من ولاية *',
    toastUpdated: 'حُدّثت بوليصة الشحن {{ewbNo}}.',
    update: 'تحديث',
    cancelTitle: 'إلغاء بوليصة الشحن {{ewbNo}}',
    cancelHint:
      'يمكن إلغاء بوليصة الشحن خلال 24 ساعة من إنشائها، قبل التحقق من البضائع أثناء النقل. لا يمكن التراجع عن ذلك.',
    reason: 'السبب',
    remark: 'ملاحظة',
    keepIt: 'الإبقاء عليها',
    toastCancelled: 'أُلغيت بوليصة الشحن {{ewbNo}}.',
  },
};
